export default __webpack_public_path__ + "static/media/device_marker_yellow.ed7047ee.svg";